import { useMutation, useQueryClient } from "@tanstack/react-query";
import { bidSubmissionDocumentsApi } from "../../../api/bidSubmissionDocuments";

export interface UploadBidSubmissionDocumentParams {
  bidSubmissionId: string;
  file: File;
  documentType: string;
  title?: string;
  description?: string;
}

export const useUploadBidSubmissionDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UploadBidSubmissionDocumentParams) => {
      const formData = new FormData();
      formData.append("file", params.file);
      formData.append("documentType", params.documentType);
      if (params.title) formData.append("title", params.title);
      if (params.description) formData.append("description", params.description);

      return bidSubmissionDocumentsApi.uploadDocument(params.bidSubmissionId, formData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bidSubmission"] });
      queryClient.invalidateQueries({ queryKey: ["bidSubmissions"] });
    },
    onError: (error) => {
      console.error("Failed to upload document:", error);
    },
  });
};

export const useRemoveBidSubmissionDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (documentId: string) => {
      return bidSubmissionDocumentsApi.removeDocument(documentId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bidSubmission"] });
      queryClient.invalidateQueries({ queryKey: ["bidSubmissions"] });
    },
    onError: (error) => {
      console.error("Failed to remove document:", error);
    },
  });
};

export const useDownloadBidSubmissionDocument = () => {
  return useMutation({
    mutationFn: async (documentId: string) => {
      // Admin users don't need vendor auth
      const response = await bidSubmissionDocumentsApi.downloadDocument(documentId, false);
      return response.data;
    },
    onError: (error) => {
      console.error("Failed to download document:", error);
    },
  });
};
